/**
 * @module response rates
 */
import { createReducer } from '@reduxjs/toolkit';

const defaultState = {};

const responseRates = createReducer(defaultState, () => {});

export default responseRates;
